/**
 * Позначка «написала — чекаю відповіді» на задачі.
 *
 * Між емодзі й текстом — U+2004, як скрізь у вебапі з v0.27.4.
 * Спільне для обох дизайнів, щоб формулювання й час збігались: Люба й
 * Таня бувають у різних темах і мають бачити те саме.
 */

/** «щойно» / «15 хв» / «2 год» / «вчора» / «3 дн» — від моменту позначки. */
export function sinceLabel(iso: string, now = Date.now()): string {
  const min = Math.max(0, Math.round((now - new Date(iso).getTime()) / 60_000));
  if (min < 2) return "щойно";
  if (min < 60) return `${min} хв`;
  const h = Math.round(min / 60);
  if (h < 24) return `${h} год`;
  const d = Math.round(h / 24);
  if (d === 1) return "вчора";
  return `${d} дн`;
}

/** Текст кнопки-позначки в обох станах. */
export function contactedText(contactedAt: string | null | undefined): string {
  return contactedAt
    ? `⏳ Чекає відповіді · ${sinceLabel(contactedAt)}`
    : "✉️ Написала";
}
